module.exports = __webpack_public_path__ + "assets/img/ba07c470f7436c5f6e149d20d280d4c7.png";